import type { ReactElement } from 'react';
import React from 'react';
import ClusterPageLayout from 'pages/clusters/layouts/cluster-page-layout';

/**
 * Displays information about the connected clusters.
 *
 * Expected to list the connected clusters,
 * what areas of data are being shared, and which users have access.
 *
 * There should also be UI to allow managing user access.
 */
export default function InfoTab(): ReactElement {
  return (
    <ClusterPageLayout>
      <div className="card">
        <h4 className="card-header">Cluster reporting available for PAT and STAR</h4>
        <div className="card-body">
          <p>
            Cluster functionality and reporting is available in Assist for PAT and STAR products. We
            can associate schools in Assist to reflect cluster or Community of Learning | Kāhui Ako
            membership. As part of the set-up process each school decides what data they will
            contribute to aggregated cluster reporting. Admin users from participating schools can
            access aggregated Year level, Stanine, and Item reports.
          </p>

          <h5>How do we get access?</h5>
          <p>
            Clusters need to be created by the Assessment Services team. We have a registration
            process to gather permissions from school leaders in each cluster. If you have questions
            about cluster reporting or the sign up process please contact our team at:{' '}
            <a href="mailto:assessmentservices@nzcer.org.nz?subject=Assist: Setup a Cluster">
              assessmentservices@nzcer.org.nz
            </a>
          </p>
        </div>
      </div>
    </ClusterPageLayout>
  );
}
